import styled from 'styled-components';

export const InvoiceFooterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  padding: 2px 10px;
  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    & p {
      color: ${({ theme }) => theme.colors.white};
      font-size: 8px;
      line-height: 10px;

      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        font-size: 12px;
        line-height: 20px;
      }
    }

    & .footer-icon-data {
      display: flex;
      align-items: center;
      gap: 6px;

      & img {
        width: 30px;
        height: 30px;

        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          width: 45px;
          height: 45px;
        }
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        gap: 15px;
      }
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 2px 40px;
  }
`;
